import React, { PureComponent } from "react";
import { branch } from "baobab-react/higher-order";
import Modal from "react-responsive-modal";
import autoBind from "react-autobind";
import { FontAwesomeIcon } from "../shared/FontAwesomeIconWrapper";
import PropTypes from "baobab-react/prop-types";

import * as playerActions from "../../actions/playerActions";
import BarcodeScanner from "./BarcodeScanner";
import PlayerPaths from "../../constants/paths/playerPaths";

const headerHeight = 50;
const footerHeight = 40;

class BarcodeScannerModal extends PureComponent {
	constructor(props) {
		super(props);
		autoBind(this);

		this.state = { paused: false };
	}

	onClickClose() {
		if (this.props.onClickClose) {
			this.props.onClickClose();
		}
	}

	// Doing at runtime...could potentially do first time loads up in state
	render() {

		const { listIndex, sectionIndex, itemIndex } = this.props;
		const selectedItem = this.context.tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex));

		let modal =
			<Modal classNames={{
				overlay: "ambifi-web-player",
				modal: "player-comments-modal",
				transitionEnter: "ambifi-web-player-modal-slide-up-enter",
				transitionEnterActive: "ambifi-web-player-modal-slide-up-enter-active",
				transitionExit: "ambifi-web-player-modal-slide-up-exit",
				transitionExitActive: "ambifi-web-player-modal-slide-up-exit-active"
			}}
				open={this.props.isOpen}
				showCloseIcon={false}
				onEntered={this.onModalEntered}
				onClose={() => { }}>
				<div ref={(c) => this._mainView = c} style={{ display: "flex", flexDirection: "column", width: "100%", height: "100%", marginTop: 0, marginLeft: 0, marginBottom: 0, marginRight: 0, alignItems: "center", justifyContent: "space-between", backgroundColor: "black" }} onLayout={() => { this._measureComponent(); }}>
					<div style={{ display: "flex", flexDirection: "column", flex: 1, alignItems: "center", justifyContent: "space-between", width: "100%", height: "100%" }}>
						<div ref={(c) => this._header = c} style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", marginTop: 5, height: headerHeight }}>
							<span style={{ fontSize: 24, color: "white" }}>Barcode Scanner</span>
						</div>
						<div style={{ display: "flex", flexDirection: "column", flex: 1, alignItems: "center", justifyContent: "center", width: "100%", height: "100%", boxSizing: "border-box" }}>
							<BarcodeScanner item={selectedItem}/>
						</div>
						<div ref={(c) => this._goBackButton = c} style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", marginBottom: 5, footerHeight: footerHeight }}>
							<div style={{ cursor: "pointer" }} onClick={() => { this.props.dispatch((tree) => playerActions.hideBarcodeScanner(tree)); }}>
								<span style={{ fontSize: 20, color: "white" }}><FontAwesomeIcon icon={"chevron-down"} style={{ marginLeft: 10, size: 20 }} /> GO BACK</span>
							</div>
						</div>
					</div>
				</div >
			</Modal>;

		return modal;
	}
}

BarcodeScannerModal.contextTypes = {
	tree: PropTypes.baobab
};

BarcodeScannerModal.defaultProps = {
};

export default branch({}, BarcodeScannerModal);